// extracted by mini-css-extract-plugin
module.exports = {"spin":"Loading_spin__189cK"};